function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.224.5321L15.0681.156 14.692 0h-4.2797a.5322.5322 0 0 0 0 1.0643h2.9947L8.1415 6.33a.5323.5323 0 0 0 0 .7525.5323.5323 0 0 0 .7525 0l5.2655-5.2654v2.995a.5322.5322 0 0 0 1.0643 0l.0002-4.28zm-1.419 9.5635v2.1127c-.002 1.6622-1.3535 3.0137-3.0158 3.0157H3.0157C1.3535 15.222.002 13.8705 0 12.2083V4.4348C.002 2.7725 1.3535 1.421 3.0157 1.419h2.1127a.5322.5322 0 0 1 0 1.0642H3.0157c-1.0696.002-1.9495.8818-1.9514 1.9515v7.7735c.002 1.0696.8818 1.9495 1.9514 1.9512h7.7735c1.0697-.002 1.9495-.8818 1.9515-1.9512v-2.1127a.5322.5322 0 0 1 1.0642 0z",
  fill: "#2C46A6",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/externalLink.1e224070.svg";
export { SvgComponent as ReactComponent };